<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">{{TitleIndex}}</p>
                <div class>
                  <div class id="tabela-alunos">
                    <section id="aluno-dashboard" class="column">
                      <section id="entity-content">
                        <aluno-form 
                          :formtitle="TitleIndex" 
                          :aluno="aluno"
                          :turmas="turmas"
                          @formSubmit="FormSubmit" 
                          :buttom="TitleForm"
                        />
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlunoService from "@/services/AlunoService";
import AlunoForm from "@/components/Forms/Aluno";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import TurmaService from "@/services/TurmaService";
import store from "@/store";

export default {
  name: "AlunoNew",
  props: [],
  created() {
    var AlunoId = this.$router.history.current.params.uuid;

    if(AlunoId != null){
      AlunoService.Info(AlunoId).then(result => {
        this.aluno = result.data;
        
        this.aluno.nascimento = new Date(this.aluno.nascimento.split(' ')[0]);
        
      });
    }
    if(this.$route.meta.cargo == 'diretor'){
        TurmaService.DiretorIndex(this.$route.meta.cargoId).then(result => {
            this.turmas = result.data;
        });
    }else{
        TurmaService.Index(this.$route.meta.cargoId).then(result => {
            this.turmas = result.data;
        });
    }
  },
  methods: {
    CreateAluno(aluno) {
      AlunoService.Create(aluno).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Aluno criado com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        this.$router.push({ name: "aluno" });
      });
    },
    UpdateAluno(aluno) {
      this.isLoading = true;
      AlunoService.Update(this.$route.params.uuid, aluno)

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "update realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
          this.$router.push({ name: "aluno" });
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    FormSubmit(aluno){
      if(this.aluno.id == ""){
        this.CreateAluno(aluno);
      }else{
        this.UpdateAluno(aluno);
      }
    }
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    AlunoForm: AlunoForm
  },
  computed: {
    TitleForm: function(){
      return this.aluno.id == "" ? "Criar Aluno" : "Editar Aluno";
    },
    TitleIndex: function(){
      return this.aluno.id == "" ? "Cadastrar Novo Aluno" : "Editar Aluno";
    }
  },
  data() {
    return {
      aluno: {
        id: "",
        credito: "",
        matricula: "",
        nascimento: new Date(),
        qr: "",
        turma_id: "",

        //user
        profile_picture: "",
        name: "",
        sobrenome: "",
        cpf: "",
        telefone: "",
        email: "",
        password: ""
      },
      turmas: {},
      cargo: store.getters.cargo
    };
  }
};
</script>